const trans_diff_path = {
    "CA12DAP_vs_CA9DAP": {
        "heatmap": "/api/static/expression/diff/CA12DAP_vs_CA9DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/CA12DAP_vs_CA9DAP_volcano.png"
    },
    "CA15DAP_vs_CA12DAP": {
        "heatmap": "/api/static/expression/diff/CA15DAP_vs_CA12DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/CA15DAP_vs_CA12DAP_volcano.png"
    },
    "CA15DAP_vs_CA9DAP": {
        "heatmap": "/api/static/expression/diff/CA15DAP_vs_CA9DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/CA15DAP_vs_CA9DAP_volcano.png"
    },
    "DAP12_vs_DAP15": {
        "heatmap": "/api/static/expression/diff/DAP12_vs_DAP15_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP12_vs_DAP15_volcano.png"
    },
    "DAP12_vs_DAP18": {
        "heatmap": "/api/static/expression/diff/DAP12_vs_DAP18_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP12_vs_DAP18_volcano.png"
    },
    "DAP12_vs_DAP21": {
        "heatmap": "/api/static/expression/diff/DAP12_vs_DAP21_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP12_vs_DAP21_volcano.png"
    },
    "DAP12_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP12_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP12_vs_DAP24_volcano.png"
    },
    "DAP15_vs_DAP18": {
        "heatmap": "/api/static/expression/diff/DAP15_vs_DAP18_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP15_vs_DAP18_volcano.png"
    },
    "DAP15_vs_DAP21": {
        "heatmap": "/api/static/expression/diff/DAP15_vs_DAP21_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP15_vs_DAP21_volcano.png"
    },
    "DAP15_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP15_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP15_vs_DAP24_volcano.png"
    },
    "DAP18_vs_DAP21": {
        "heatmap": "/api/static/expression/diff/DAP18_vs_DAP21_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP18_vs_DAP21_volcano.png"
    },
    "DAP18_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP18_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP18_vs_DAP24_volcano.png"
    },
    "DAP21_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP21_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP21_vs_DAP24_volcano.png"
    },
    "DAP6_vs_DAP12": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP12_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP12_volcano.png"
    },
    "DAP6_vs_DAP15": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP15_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP15_volcano.png"
    },
    "DAP6_vs_DAP18": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP18_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP18_volcano.png"
    },
    "DAP6_vs_DAP21": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP21_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP21_volcano.png"
    },
    "DAP6_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP24_volcano.png"
    },
    "DAP6_vs_DAP9": {
        "heatmap": "/api/static/expression/diff/DAP6_vs_DAP9_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP6_vs_DAP9_volcano.png"
    },
    "DAP9_vs_DAP12": {
        "heatmap": "/api/static/expression/diff/DAP9_vs_DAP12_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP9_vs_DAP12_volcano.png"
    },
    "DAP9_vs_DAP15": {
        "heatmap": "/api/static/expression/diff/DAP9_vs_DAP15_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP9_vs_DAP15_volcano.png"
    },
    "DAP9_vs_DAP18": {
        "heatmap": "/api/static/expression/diff/DAP9_vs_DAP18_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP9_vs_DAP18_volcano.png"
    },
    "DAP9_vs_DAP21": {
        "heatmap": "/api/static/expression/diff/DAP9_vs_DAP21_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP9_vs_DAP21_volcano.png"
    },
    "DAP9_vs_DAP24": {
        "heatmap": "/api/static/expression/diff/DAP9_vs_DAP24_heatmap.png",
        "volcano": "/api/static/expression/diff/DAP9_vs_DAP24_volcano.png"
    },
    "JNP12DAP_vs_JNP15DAP": {
        "heatmap": "/api/static/expression/diff/JNP12DAP_vs_JNP15DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP12DAP_vs_JNP15DAP_volcano.png"
    },
    "JNP12DAP_vs_JNP18DAP": {
        "heatmap": "/api/static/expression/diff/JNP12DAP_vs_JNP18DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP12DAP_vs_JNP18DAP_volcano.png"
    },
    "JNP12DAP_vs_JNP24DAP": {
        "heatmap": "/api/static/expression/diff/JNP12DAP_vs_JNP24DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP12DAP_vs_JNP24DAP_volcano.png"
    },
    "JNP15DAP_vs_JNP18DAP": {
        "heatmap": "/api/static/expression/diff/JNP15DAP_vs_JNP18DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP15DAP_vs_JNP18DAP_volcano.png"
    },
    "JNP15DAP_vs_JNP24DAP": {
        "heatmap": "/api/static/expression/diff/JNP15DAP_vs_JNP24DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP15DAP_vs_JNP24DAP_volcano.png"
    },
    "JNP18DAP_vs_JNP24DAP": {
        "heatmap": "/api/static/expression/diff/JNP18DAP_vs_JNP24DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP18DAP_vs_JNP24DAP_volcano.png"
    },
    "JNP9DAP_vs_JNP12DAP": {
        "heatmap": "/api/static/expression/diff/JNP9DAP_vs_JNP12DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP9DAP_vs_JNP12DAP_volcano.png"
    },
    "JNP9DAP_vs_JNP15DAP": {
        "heatmap": "/api/static/expression/diff/JNP9DAP_vs_JNP15DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP9DAP_vs_JNP15DAP_volcano.png"
    },
    "JNP9DAP_vs_JNP18DAP": {
        "heatmap": "/api/static/expression/diff/JNP9DAP_vs_JNP18DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP9DAP_vs_JNP18DAP_volcano.png"
    },
    "JNP9DAP_vs_JNP24DAP": {
        "heatmap": "/api/static/expression/diff/JNP9DAP_vs_JNP24DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/JNP9DAP_vs_JNP24DAP_volcano.png"
    },
    "ZY12DAP_vs_CA12DAP": {
        "heatmap": "/api/static/expression/diff/ZY12DAP_vs_CA12DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY12DAP_vs_CA12DAP_volcano.png"
    },
    "ZY12DAP_vs_ZY9DAP": {
        "heatmap": "/api/static/expression/diff/ZY12DAP_vs_ZY9DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY12DAP_vs_ZY9DAP_volcano.png"
    },
    "ZY15DAP_vs_CA15DAP": {
        "heatmap": "/api/static/expression/diff/ZY15DAP_vs_CA15DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY15DAP_vs_CA15DAP_volcano.png"
    },
    "ZY15DAP_vs_ZY12DAP": {
        "heatmap": "/api/static/expression/diff/ZY15DAP_vs_ZY12DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY15DAP_vs_ZY12DAP_volcano.png"
    },
    "ZY15DAP_vs_ZY9DAP": {
        "heatmap": "/api/static/expression/diff/ZY15DAP_vs_ZY9DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY15DAP_vs_ZY9DAP_volcano.png"
    },
    "ZY9DAP_vs_CA9DAP": {
        "heatmap": "/api/static/expression/diff/ZY9DAP_vs_CA9DAP_heatmap.png",
        "volcano": "/api/static/expression/diff/ZY9DAP_vs_CA9DAP_volcano.png"
    }
};
export default trans_diff_path;
